import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import toast from "react-hot-toast";
import { Triangle } from "react-loader-spinner";
import PageService from "../../services/KangarooServices/PageService";
import DeleteModal from "../../Components/Common/DeleteModal";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { imageBaseApi } from "../../utilis/imageHelper";
 // adjust path as needed

const GeneralPages = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({ search: "", status: "" });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleFilterChange = (e) => {
    setFilters((prev) => ({ ...prev, search: e.target.value }));
  };
  const fetchPage = async (
    page = 1,
    size = pageSize,
    currentFilters = debouncedFilters
  ) => {
    setIsLoading(true);
    try {
      const response = await PageService.getIntellList({
        ...currentFilters,
        page,
        pageSize: size,
      });
      setData(response.items);
      setTotalRows(response.totalCount); //Total Rows
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedFilters(filters);
      setCurrentPage(1);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [filters]);

  useEffect(() => {
    fetchPage(currentPage, pageSize);
  }, [currentPage, pageSize, debouncedFilters]);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await PageService.delete(selectedDeleteItem.id);
        fetchPage(currentPage, pageSize);
        toast.success("Page deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  // Pagination controls
  const totalPages = Math.ceil(totalRows / pageSize);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };
  console.log(data);

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Pages List" pageTitle="Pages" />
        <Row>
          <Col lg={6} className="d-flex  mb-2">
            <InputGroup className="w-auto">
              <Input
                placeholder="Search..."
                value={filters.search}
                onChange={handleFilterChange}
              />
            </InputGroup>
          </Col>
          <Col
            md={4}
            xs={12}
            lg={6}
            className="d-flex justify-content-end align-items-end mb-2"
          >
            <Button
              className="btn btn-success"
              onClick={() => navigate("/pages/create")}
            >
              + Create Page
            </Button>
          </Col>
        </Row>
        {isLoading ? (
          <div className="my-3 d-flex justify-content-center align-items-center">
            <Triangle height="100" width="100" color="#556ee6" />
          </div>
        ) : (
          <>
            <Row className="g-4">
              {data?.map((item) => (
                <Col md={12} key={item.id}>
                  <Card className="shadow-sm border-0 h-100 rounded-3 page-card">
                    <Row className="g-0">
                      {/* Image Section */}
                      <Col lg={4}>
                        <div className="h-100 d-flex align-items-center align-content-center justify-content-center p-2 bg-light rounded-start">
                          <img
                            src={
                              item?.featuredMedia?.url
                                ? `${imageBaseApi}${item.featuredMedia.url}`
                                : blog
                            }
                            alt="thumb"
                            className="img-fluid rounded-3 card-thumb"
                            style={{
                              height: "40vh",
                              objectFit: "contain",
                              width: "100%",
                            }}
                          />
                        </div>
                      </Col>

                      {/* Content Section */}
                      <Col lg={8}>
                        <CardBody className="d-flex flex-column h-100">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <small className="text-muted">
                              {item.slug || "-"}
                            </small>
                            {/* <div className="d-flex justify-content-between align-items-center ">
                              <Badge
                                pill
                                className={`${
                                  item.status === "Draft"
                                    ? "bg-warning text-dark"
                                    : "bg-success"
                                }`}
                              >
                                {item.status}
                              </Badge>
                            </div> */}
                            <div className="d-flex justify-content-between align-items-center ">
                              <Badge
                                color={
                                  item.status?.toLowerCase() === "draft"
                                    ? "info" // blue
                                    : "success" // green
                                }
                              >
                                {item.status}
                              </Badge>
                            </div>
                          </div>

                          <h5 className="mb-1 fw-semibold text-dark">
                            {item.title}
                          </h5>
                          {item.subtitle && (
                            <p className="text-muted fst-italic small mb-2">
                              {item.subtitle}
                            </p>
                          )}

                          <div className="d-flex align-items-center mb-3 text-muted small">
                            <i className="bx bx-calendar me-1"></i>
                            {moment(item.createdAt).format(
                              "YYYY-MM-DD hh:mm A"
                            )}
                          </div>
                          

                          <div
                            className="content-preview small mb-2"
                            style={{ overflow: "hidden", lineHeight: "1.4" }}
                            dangerouslySetInnerHTML={{
                              __html:
                                item.content?.length > 300
                                  ? item.content.slice(0, 300) + "..."
                                  : item.content,
                            }}
                          />
                          <div className="d-flex justify-content-between align-items-center border-top pt-3">
                            <span
                              className="text-primary small fw-semibold cursor-pointer "
                              onClick={() =>
                                navigate(`/pages-list/${item?.slug}`)
                              }
                            >
                              Read More →
                            </span>
                            <div className="d-flex gap-2">
                              <Button
                                size="sm"
                                color="warning"
                                className="d-flex align-items-center gap-1"
                                onClick={() =>
                                  navigate(`/pages/update/${item.slug}`)
                                }
                              >
                                <i className="ri-edit-line"></i>
                              </Button>
                              <Button
                                size="sm"
                                color="danger"
                                className="d-flex align-items-center gap-1"
                                onClick={() => handleDeleteClick(item)}
                              >
                                <i className="ri-delete-bin-5-line"></i>
                              </Button>
                            </div>
                          </div>
                        </CardBody>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Pagination */}
            {totalPages > 0 && (
              <div className="d-flex justify-content-center my-4 sticky-bottom">
                <Pagination className="mb-0">
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      previous
                      onClick={() => handlePageChange(currentPage - 1)}
                    />
                  </PaginationItem>

                  {Array.from({ length: Math.min(7, totalPages) }, (_, i) => {
                    const page = currentPage <= 4 ? i + 1 : i + currentPage - 4;
                    if (page > totalPages) return null;
                    return (
                      <PaginationItem key={page} active={currentPage === page}>
                        <PaginationLink onClick={() => setCurrentPage(page)}>
                          {page}
                        </PaginationLink>
                      </PaginationItem>
                    );
                  })}

                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      next
                      onClick={() => handlePageChange(currentPage + 1)}
                    />
                  </PaginationItem>
                </Pagination>
              </div>
            )}
          </>
        )}
      </div>

      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </Container>
  );
};

export default GeneralPages;
